import Vue from 'vue'
import Router from 'vue-router'

// 首页
const Index = r => require.ensure([], () => r(require('@/view/Index')), '/index')
// 企业列表
const CompanyList = r => require.ensure([], () => r(require('@/view/company/List')), '/company')
// 网站列表
const WebsiteList = r => require.ensure([], () => r(require('@/view/website/List')), '/web')
// 网站详情
const WebsiteDetail = r => require.ensure([], () => r(require('@/view/website/Detail')), '/webDetail')
// 商品列表
const ProductList = r => require.ensure([], () => r(require('@/view/product/List')), '/product')
// 上市企业搜索
const ListedCompanySearch = r => require.ensure([], () => r(require('@/view/listedCompany/Search')), '/listedCompany')
// 上市企业列表
const ListedCompanyList = r => require.ensure([], () => r(require('@/view/listedCompany/List')), '/listedCompany')
// 机构搜索
const OrganizationSearch = r => require.ensure([], () => r(require('@/view/organization/Search')), '/institution')
// 机构列表
const OrganizationList = r => require.ensure([], () => r(require('@/view/organization/List')), '/institution')

// 网站安全服务查询首页
const SafeService = r => require.ensure([], () => r(require('@/view/specialCheck/safeService')), '/safeService')
// 网站安全服务查询首页跳转到结果页面
const SafeResult = r => require.ensure([], () => r(require('@/view/specialCheck/safeService/safeResult')), '/safeResult')
// 网站安全服务查询首页
const shopService = r => require.ensure([], () => r(require('@/view/specialCheck/shopService')), '/shopService')
// 网站安全服务查询首页跳转到结果页面
const shopResult = r => require.ensure([], () => r(require('@/view/specialCheck/shopService/shopResult')), '/shopResult')
// AI可信身份认证证书查询首页(购物码新平台证书图直连,无后端接口)
const aiCertService = r => require.ensure([], () => r(require('@/view/specialCheck/aiCertService')), '/aiCertService')
// AI可信身份认证证书查询结果页
const aiCertResult = r => require.ensure([], () => r(require('@/view/specialCheck/aiCertService/aiCertResult')), '/aiCertResult')
const certificateShow  = r => require.ensure([], () => r(require('@/view/showCerfiticate/index')), '/safeResult')
// 存证查询
const EvidenceSearch = r => require.ensure([], () => r(require('@/view/specialCheck/evidenceSearch/index')), '/evidenceSearch')
const EvidenceResult = r => require.ensure([], () => r(require('@/view/specialCheck/evidenceSearch/evidenceResult')), '/evidenceSearch')


// 专项查验首页
const Inspection = r => require.ensure([], () => r(require('@/view/specialCheck/inspection/index')), '/inspection')
// 专项查验结果
const InspectionResult = r => require.ensure([], () => r(require('@/view/specialCheck/inspection/inspectionResult')), '/inspectionResult')



// 企业自述模块
const readme = r => require.ensure([], () => r(require('@/view/readme/App')), '/readme')
// 首页
const readmeIndex = r => require.ensure([], () => r(require('@/view/readme/readme/Index')), '/readmeIndex')
// 自述服务列表
const readmeSevrice = r => require.ensure([], () => r(require('@/view/readme/service/Service')), '/readmeSevrice')
// 自述服务公告列表
const readmeNotices = r => require.ensure([], () => r(require('@/view/readme/notices/Notices')), '/readmeNotices')
// 自述服务公告列表
const readmePhoto = r => require.ensure([], () => r(require('@/view/readme/photo/Photo')), '/readmePhoto')
// 自述服务公告详情
const noticeDetail = r => require.ensure([], () => r(require('@/view/readme/notices/Detail')), '/readmeNoticeDetail')

Vue.use(Router)

export default new Router({
    mode: 'history',
    fallback: false, // ie强制去#号
    routes: [
        /*{
            path: '/',
            name: 'index',
            component: Index
        },*/
        { // 企业列表
            path: '/s/company',
            name: 'companyList',
            component: CompanyList
        },
        { // 网站列表
            path: '/s/web',
            name: 'websiteList',
            component: WebsiteList
        },
        { // 网站详情
            path: '/web/detail',
            name: 'WebsiteDetail',
            component: WebsiteDetail
        },
        { // 商品列表
            path: '/s/product',
            name: 'productList',
            component: ProductList
        },
        { // 机构搜索
            path: '/institution',
            name: 'organizationSearch',
            component: OrganizationSearch
        },
        { // 机构列表
            path: '/s/institution',
            name: 'organizationList',
            component: OrganizationList
        },

        /*{// 网站安全服务查询首页
            path: '/safeService',
            name: 'safeService',
            component: SafeService
        },
        {// 网站安全服务查询首页
            path: '/safeResult',
            name: 'safeResult',
            component: SafeResult
        },*/

        {// 专项查验查询首页
            path: '/safeService',
            name: 'Inspection',
            component: Inspection
        },

        {// 专项查验查询首页
            path: '/safeResult',
            name: 'inspectionResult',
            component: InspectionResult
        },
        {// 专项查验查询首页
            path: '/shopService',
            name: 'shopService',
            component: shopService
        },

        

        {// 专项查验查询首页
            path: '/shopResult',
            name: 'shopResult',
            component: shopResult
        },

        {// AI可信身份认证证书查询首页
            path: '/aiCertService',
            name: 'aiCertService',
            component: aiCertService
        },

        {// AI可信身份认证证书查询结果页
            path: '/aiCertResult',
            name: 'aiCertResult',
            component: aiCertResult
        },

        {// 专项证书显示
            path: '/certificateShow',
            name: 'certificateShow',
            component: certificateShow
        },

        {// 存证查询
            path: '/evidenceSearch',
            name: 'evidenceSearch',
            component: EvidenceSearch
        },
        {// 存证查询结果
            path: '/evidenceResult',
            name: 'evidenceResult',
            component: EvidenceResult
        },





        { // 上市企业搜索
            path: '/listedCompany',
            name: 'listedCompanySearch',
            component: ListedCompanySearch
        },
        { // 上市企业列表
            path: '/s/listedCompany',
            name: 'listedCompanyList',
            component: ListedCompanyList
        },

        // 企业自述模块

        { // 企业自述模块(详情页走 cp PHP SSR 不进 SPA;:publicId 占位规范,readme 组件仍读全局 companyId)
            path: '/detail/:publicId',
            name: 'readme',
            component: readme,
            children: [
            {
                path: '/detail/:publicId/readme',
                component: readmeIndex,
                name: 'readmeIndex'
            },
            { // 自述服务列表
                path: '/detail/:publicId/service',
                component: readmeSevrice,
                name: 'readmeSevrice'
            },
            {
                path: '/detail/:publicId/notices',
                component: readmeNotices,
                name:'readmeNotices'
            },
            {
                path: '/detail/:publicId/photo',
                component: readmePhoto,
                name:'readmePhoto'
            },
            {
                path: '/detail/:publicId/noticeDetail/:id',
                name: 'NoticeDetail',
                component: noticeDetail,

            }
            ]
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            // document.body.scrollTop = 200
            // document.documentElement.scrollTop = 200
            // console.log(111)
            return {
                selector: to.hash
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js